import React from "react";
import "./../../style.scss";
import { withStyles, Table, Paper, TableBody, withTheme } from "@material-ui/core";
import styles from "./styles";
import { formatAddress } from "../../../../modules/Dispatch/utils/utils";
import Header from "../components/Header";
import Content from "../components/Content";
import Footer from "../components/Footer";
import Contact from "../components/Contact";
import {
  getPickupStopContact,
  getPickupContent,
  getDriverDetails,
  getClosingSoonDetails,
} from "../utils";
import UnAssignPickup from "../components/UnAssignPickup";
import { PickupPopupMarker, VirtualStopMarker } from "../../../Markers";
import { compose } from "recompose";
import { getPickupStopWithPickupList } from "../../PopupUtil";
import ShowPickupNumbers from "../components/ShowPickupNumbers";

const StopPickupPopupInfo = ({
  classes,
  theme,
  unAssignDriver,
  hideAction,
  pickupId,
  isDelayStop,
  specialNeeds,
  stopData,
  routesData,
  terminalOffset,
  openDriverChat,
  closingSoonLimitConfig,
  glEventHub,
  showPickupHistory = true
}) => {
  const address = formatAddress({
    address: stopData?.address,
    address2: stopData?.address2,
    city: stopData?.city,
    state: stopData?.state,
    zip: stopData?.zip,
  });

  const unAssignPickupStop = (stopData) => {
    const pickupDetails = stopData.pickupIdList.map((pickupId) => ({
      pickupId: pickupId,
      groupId: stopData.groupId,
      driverId: routesData.driverId
    }));
    unAssignDriver(pickupDetails);
  };
  const { closingSoonTextClasses, closingSoonText, closingSoonTime } =
    getClosingSoonDetails({
      isActivePickup: !hideAction,
      closeTime: stopData.closeTime,
      terminalOffset,
      closingSoonLimitConfig,
    });
  return (
    <Paper className={`popupBGColor ${classes.mapPopupContainer}`}>
      <Table className={classes.table} padding="none">
        <Header
          name={stopData.name}
          address={address}
          stopSequence={stopData.stopSequence}
          isDelayStop={isDelayStop}
          Marker={stopData.isVirtualStop ? VirtualStopMarker : PickupPopupMarker}
          markerProps={{ backgroundColor: stopData.color }}
          pickupPriority={stopData.pickupPriority}
          themeColors={{
            color: theme.headFontColor
          }}
        />
        <TableBody>
          <Contact {...getPickupStopContact(stopData)} />
          {hideAction ? null : (
            <UnAssignPickup
              unAssignDriver={() =>unAssignPickupStop(stopData)
              }
            />
          )}
          <ShowPickupNumbers 
            pickupNumberIdList={getPickupStopWithPickupList(stopData).pickupNumberIdList}
            glEventHub={glEventHub}
          />
          <Content
            data={getPickupContent(stopData)}
            stopData={stopData}
            specialNeeds={specialNeeds}
            closingSoonText={closingSoonText}
            closingSoonTextClasses={closingSoonTextClasses}
          />
        </TableBody>
        <Footer
          stopData={stopData}
          driverDetails={getDriverDetails(routesData, terminalOffset)}
          openDriverChat={openDriverChat}
          closingSoonTime={closingSoonTime}
          closingSoonLimitConfig={closingSoonLimitConfig}
          glEventHub={glEventHub}
          pickupId={pickupId}
          showPickupHistory={showPickupHistory}
        />
      </Table>
    </Paper>
  );
};

export default compose(withStyles(styles), withTheme())(StopPickupPopupInfo);
